import { render } from "./StatisticsPage.vue?vue&type=template&id=d26e0928&ts=true"
import script from "./StatisticsPage.vue?vue&type=script&lang=ts"
export * from "./StatisticsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__